const formatDateTime = (dateTime: Date, language: string, options: Intl.DateTimeFormatOptions) =>
  new Intl.DateTimeFormat(language, options).format(dateTime);

const formatDate = (date: Date, language: string, options?: Intl.DateTimeFormatOptions) =>
  formatDateTime(date, language, { day: 'numeric', month: 'numeric', ...options });

const formatTime = (time: Date, language: string, options?: Intl.DateTimeFormatOptions) =>
  formatDateTime(time, language, { hour: '2-digit', minute: '2-digit', ...options });

export { formatDate, formatTime };
